module.exports = __webpack_public_path__ + "img/store-ebay.4021498c.svg";